<div class="whitelistSpacer">
  <div class="whitelistUrlView">
    <h3>DOMAIN ACCESSIBILITY</h3>
    <p class="desc">
      {{domainLabel}}
    </p>
    <br />
    <div class="tab">
      @for (whitelist of productResults; track whitelist) {
        <ul class="tab1"
          [class.active-border-selection]="productName == whitelist.name">
          <li id="{{whitelist.name}}" (click)="tabChange(whitelist.name)">{{whitelist.name}}</li>
        </ul>
      }

      <div class="content">
        @for (whitelist of productResults; track whitelist) {
          <div>
            @if (productName === whitelist.name) {
              <div class="content-value">
                @if (whitelist.hasAutoResults === true) {
                  <div>
                    <p>
                      {{autoResultLabel}}
                    </p>
                    <table class="whitelistTable">
                      <thead>
                        <tr class="whitelistTableHeaderRow">
                          <th class="whitelistTableHeader">DOMAIN</th>
                          <th class="whitelistTableHeader">ELAPSED TIME</th>
                          <th class="whitelistTableHeader">STATUS</th>
                        </tr>
                      </thead>
                      @for (urlValidationResult of whitelist.autoResults; track urlValidationResult) {
                        <tbody>
                          <tr class="whitelistTableRow">
                            <td class="whitelistTableCell">{{urlValidationResult?.domain}}</td>
                            <td class="whitelistTableCell">{{urlValidationResult?.responseTime}} ms</td>
                            <td class="whitelistTableCell">{{urlValidationResult?.responseStatus}}</td>
                          </tr>
                        </tbody>
                      }
                    </table>
                    <br />
                  </div>
                }
                @if (whitelist.hasImageDomains === true) {
                  <div>
                    <p>
                      {{imageDomainLabel}}
                    </p>
                    <table class="whitelistTable">
                      <thead>
                        <tr class="whitelistTableHeaderRow">
                          <th class="whitelistTableHeader">DOMAIN</th>
                          <th class="whitelistTableHeader">IMAGE</th>
                        </tr>
                      </thead>
                      @for (urlValidationResult of whitelist.imageDomains; track urlValidationResult) {
                        <tbody>
                          <tr class="whitelistTableRow">
                            <td class="whitelistTableCell"> {{urlValidationResult?.domain}}</td>
                            <td class="whitelistTableImageCell"><img class="whitelistImage"
                            src="{{urlValidationResult?.urlToTest}}"></td>
                          </tr>
                        </tbody>
                      }
                    </table>
                    <br />
                  </div>
                }
                @if (whitelist.hasManualDomains === true) {
                  <div>
                    <p>
                      {{manualDomainLabel}}
                    </p>
                    <table class="whitelistTable">
                      <thead>
                        <tr class="whitelistTableHeaderRow">
                          <th class="whitelistTableHeader">DOMAINS REQUIRING MANUAL TESTING</th>
                          <th class="whitelistTableHeader">EXPECTED BEHAVIOR</th>
                          <th class="whitelistTableHeader"></th>
                        </tr>
                      </thead>
                      @for (urlValidationResult of whitelist.manualDomains; track urlValidationResult) {
                        <tbody>
                          <tr class="whitelistTableRow">
                            <td class="whitelistTableCell">{{urlValidationResult?.domain}}</td>
                            <td class="whitelistTableCell">{{urlValidationResult?.expected}}</td>
                            <td class="whitelistTableCell"><a
                              href="{{urlValidationResult?.urlToTest}}" target="newWin">Test
                            Domain Access</a></td>
                          </tr>
                        </tbody>
                      }
                    </table>
                    <br />
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <br>
      <button class="btn" type="button" onClick="window.location.reload();">Validate URL Accessibility</button>
      <br />
    </div>
  </div>